export { default } from './DefaultPageLayout';
